import React, { useMemo, useState } from "react";
import {
  AutocompleteComponent,
  CustomAutocomplete,
  ReskinningAutocomplete,
} from "../../../../../Components";
import useFetchData from "../../../../../Hooks/useFetchData";
import { useDebouncedAction } from "../../../../../Hooks/DebouncedAction";
import { GetVendorsAdvanceSearchAPI } from "../../../../../Services";
import { useLayoutDetection } from "../../../../../Hooks";

const VendorAutocomplete = ({ onChange, ...props }) => {
  const [searchText, setSearchText] = useState("");
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();

  const isNewLayout = isReskinningLayout && hasNewLayout;

  const pagination = useMemo(
    () => ({
      pageSize: 25,
      pageIndex: 0,
    }),
    []
  );
  const body = useMemo(
    () => ({
      criteria: !!searchText
        ? {
            "vendor_name.name": [
              {
                searchType: 2,
                value: searchText,
              },
            ],
          }
        : undefined,
    }),
    [searchText]
  );
  const { data, loading } = useFetchData(
    GetVendorsAdvanceSearchAPI,
    pagination,
    body
  );
  const debouncedSetSearchText = useDebouncedAction(setSearchText);
  return !isNewLayout ? (
    <AutocompleteComponent
      withoutSearchButton
      data={data.result ?? []}
      isLoading={loading}
      isDisabled={loading}
      onInputChange={(_e, value) => debouncedSetSearchText(value)}
      displayLabel={(option) => option?.vendor.vendor.vendor_name.name ?? ""}
      multiple={false}
      onChange={(_e, newValue) => onChange(newValue)}
      {...props}
    />
  ) : (
    <ReskinningAutocomplete
      withoutSearchButton
      data={data.result ?? []}
      isLoading={loading}
      isDisabled={loading}
      onInputChange={(_e, value) => debouncedSetSearchText(value)}
      displayLabel={(option) => option?.vendor.vendor.vendor_name.name ?? ""}
      multiple={false}
      onChange={(_e, newValue) => onChange(newValue)}
      {...props}
    />
  );
};
export default VendorAutocomplete;
